import { render } from "./modifypwd.vue?vue&type=template&id=84568afc"
import script from "./modifypwd.vue?vue&type=script&lang=js"
export * from "./modifypwd.vue?vue&type=script&lang=js"

import "./modifypwd.vue?vue&type=style&index=0&id=84568afc&lang=less"
script.render = render

export default script